import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import {
  editEventTemplate,
  deleteEventTemplate,
} from '@pingum/app-state-management/eventTemplate/actions';

export class ArchiveDeleteTaskModalComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  // handleDeleteConfirm = () => {
  //   // eslint-disable-next-line no-debugger
  //   this.props.eventTemplateIds.forEach((eventTemplateId) => this.props.deleteEventTemplate(eventTemplateId)
  //     .then(() => { this.setState({ error: null }); this.props.handleCloseModal(true); })
  //     .catch((error) => { this.setState({ error: (error && error.message) || 'There was an error deleting this template.' }); }));
  // }

  handleArchiveConfirm = () => {
    this.setState({ error: null });
    this.props.eventTemplateIds.forEach((eventTemplateId) => this.props.editEventTemplate(eventTemplateId, { archived: true }));
    this.props.handleCloseModal(true);
  }

  render() {
    const { eventTemplateIds } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.handleCloseModal}
          aria-labelledby="edit-user-title"
          aria-describedby="edit-user-description"
        >
          <DialogTitle>
            {
              eventTemplateIds.length === 1
                ? 'Delete Calendar Event'
                : 'Delete Calendar Events'
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <strong>Are you sure you want to perform this action?</strong>
            </DialogContentText>
            <DialogContentText>
              <strong>Deleting</strong> will remove the calendar type from your list of available calendar events.
            </DialogContentText>
          </DialogContent>
          { this.state.error && <Typography variant="caption" align="right" component="div" gutterBottom color="error">{this.state.error}</Typography>}
          <DialogActions>
            {/* <Button
              onClick={() => { this.handleDeleteConfirm(); }}
              sx={{ mr: 1 }}
              color="error"
              autoFocus
            >
              Delete
            </Button> */}
            <Button
              onClick={() => { this.handleArchiveConfirm(); }}
              color="error"
              autoFocus
              sx={{ mr: 1 }}
            >
              Delete
            </Button>
            <Button color="primary" variant="contained" onClick={this.props.handleCloseModal}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ArchiveDeleteTaskModalComponent.propTypes = {
  eventTemplateIds: PropTypes.arrayOf(PropTypes.number),
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  editEventTemplate: PropTypes.func,
  // deleteEventTemplate: PropTypes.func,
};

ArchiveDeleteTaskModalComponent.defaultProps = {
  eventTemplateIds: [],
  isOpen: false,
  handleCloseModal: () => { },
  editEventTemplate: () => {},
  // deleteEventTemplate: () => {},
};

export const mapDispatchToProps = (dispatch) => ({
  editEventTemplate: (eventTemplateId, request) => dispatch(editEventTemplate(eventTemplateId, request)),
  deleteEventTemplate: (eventTemplateId) => dispatch(deleteEventTemplate(eventTemplateId)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ArchiveDeleteTaskModalComponent);
